import request from '@/utils/request'

// 获取门禁列表
export function getIocToken(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/huaFangIOC.getToken',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve({
          data: res.data,
        })
      } else {
        reject(new Error(res.msg))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
export function daHuaICCToken(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/daHuaICC.getToken',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve({
          data: res.data,
        })
      } else {
        reject(new Error(res.msg))
      }
    }).catch(error => {
      reject(error)
    })
  })
}